var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-podcast"},[(_vm.podigee)?_c('iframe',{staticClass:"podigee-podcast-player",attrs:{"src":'https://cdn.podigee.com/podcast-player/podigee-podcast-player.html?configuration=' +
        _vm.podcast +
        '/embed?context=external'}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.podcast)}})])}
var staticRenderFns = []

export { render, staticRenderFns }